<template>
  <div @click="toogleAudio" :class="{ 'hide': !src }" class="audioplayer" >
    <audio
      ref="audio"
      :src="'/media/' + src"
      :loop="true"
      :autoplay="wasPlaying"
      @play="onAudioPlay"
      @pause="onAudioPause"
    />
    <AudioIcon :playing="isPlaying" />
  </div>
</template>

<script>
import AudioIcon from '@/atoms/SoundIconWithAnimation.vue'
import { gsap } from 'gsap'

export default {
  components: { AudioIcon },

  data () {
    return {
      wasPlaying: true,
      isPlaying: false,
      src: null
    }
  },

  async mounted () {
    await this.$nextTick()
    this.createTimeline()

    this.$events.on('room-has-audio', this.onRoomChange)

    this.$events.on('room-has-no-audio', this.onRoomChange)

    this.$events.on('audioguide-play', () => { if (this.src) this.pauseAudio() })

    this.$events.on('audioguide-pause', () => {
      if (this.src && this.wasPlaying) { this.playAudio() }
    })
  },

  computed: {
    player () {
      return this.$refs.audio
    }
  },

  methods: {
    createTimeline () {
      this.tl = gsap.timeline({ paused: true })
      this.tl.addLabel('pause')
      this.tl.fromTo(this.player, { volume: 0 }, { volume: 1, duration: 0.5 })
      this.tl.addLabel('play')
    },
    toogleAudio () {
      if (this.isPlaying) {
        this.pauseAudio()
      } else {
        this.playAudio()
      }
      this.wasPlaying = !this.isPlaying
    },
    playAudio () {
      this.player.play()
    },
    pauseAudio () {
      this.tl.tweenTo('pause', { onComplete: () => { this.player.pause() } })
    },
    onAudioPlay () {
      this.$events.$emit('room-audio-play')
      this.isPlaying = true
      this.wasPlaying = true
      this.tl.tweenTo('play')
    },
    onAudioPause () {
      this.$events.$emit('room-audio-pause')
      this.isPlaying = false
    },
    onRoomChange (audio) {
      if (this.src === audio) return
      if (!this.isPlaying) {
        this.src = audio
      } else {
        this.tl.tweenTo('pause', {
          onComplete: () => {
            this.player.pause()
            this.src = audio
            if (audio && this.wasPlaying) this.playAudio()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.audioplayer.hide {
  display: none;
}
</style>
